// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PGhWIr5uBGDj4B9QO3jG {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.do2exQYhwlRBEtaZmAY9 {
  width: 100%;
  display: flex;
  flex-direction: column;
  padding-right: 32px;
}

.oiZi707Y7WqFhaJYa4HH {
  display: flex;
  align-items: center;
  gap: 12px;
  padding-bottom: 8px;
}

.iXBZhAVheyrETYU3jqWv {
  font-size: 16px;
  font-family: var(--font-stack-full-heavy);
  font-weight: 800;
  line-height: 24px;
  color: var(--grey-color-90);
}

.dUBbt_VnJ4T0pIvIF9Li {
  font-family: var(--font-stack-full-book);
  font-weight: 350;
  line-height: 24px;
  font-size: 16px;
  color: var(--grey-color-90);
}

.qIz1w2NKWmasVc4o7VFQ {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.Z60KmyMROohtV56fOFgf {
  width: 100%;
  padding: 10px 40px;
}

.TYbnX3wOnFS_GpK4TiLg {
  width: 100%;
  height: 6px;
  border-radius: 4px;
  background-color: #b0caeb;
  display: flex;
  position: relative;
}

.CKW5EO_SE3xhFeANdJiI {
  background-color: #3973ca;
  height: 6px;
  border-radius: 4px;
}

.QWOz8L2zbgLinA_iHXv8 {
  width: 15px;
  height: 15px;
  margin-top: -5px;
  border: 1px solid var(--grey-gradient-start-color-10);
  border-radius: 50%;
  background-color: #3973ca;
  position: absolute;
  z-index: 1;
}

.XdNMUmGodrJ6IuSrMf9o {
  position: absolute;
  height: 6px;
  width: 4px;
  background-color: var(--grey-gradient-start-color-10);
}

.Fu9Os8DK2rKKIvgdONcw {
  display: flex;
  justify-content: space-between;
}

.evZ09L9aPPpEEfhlZSw5 {
  width: 100%;
}
.evZ09L9aPPpEEfhlZSw5:first-child {
  padding-left: 40px;
}

.b4FPr6Z_Hw1NwUCIf0xY {
  position: relative;
  left: -36px;
  top: 10px;
}`, "",{"version":3,"sources":["webpack://./src/components/SuccessProfilesSkillGroup/Skill/Skill.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;AACF;;AAEA;EACE,WAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;AACF;;AAEA;EACE,eAAA;EACA,yCAAA;EACA,gBAAA;EACA,iBAAA;EACA,2BAAA;AACF;;AAEA;EACE,wCAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;EACA,2BAAA;AACF;;AAEA;EACE,WAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AACF;;AAEA;EACE,WAAA;EACA,kBAAA;AACF;;AAEA;EACE,WAAA;EACA,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,aAAA;EACA,kBAAA;AACF;;AAEA;EACE,yBAAA;EACA,WAAA;EACA,kBAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,gBAAA;EACA,qDAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,UAAA;AACF;;AAEA;EACE,kBAAA;EACA,WAAA;EACA,UAAA;EACA,qDAAA;AACF;;AAEA;EACE,aAAA;EACA,8BAAA;AACF;;AAEA;EACE,WAAA;AACF;AAAE;EACE,kBAAA;AAEJ;;AAEA;EACE,kBAAA;EACA,WAAA;EACA,SAAA;AACF","sourcesContent":[".skillContainer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.skillLeftContainer {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  padding-right: 32px;\n}\n\n.skillNameContainer {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding-bottom: 8px;\n}\n\n.skillName {\n  font-size: 16px;\n  font-family: var(--font-stack-full-heavy);\n  font-weight: 800;\n  line-height: 24px;\n  color: var(--grey-color-90);\n}\n\n.skillDescription {\n  font-family: var(--font-stack-full-book);\n  font-weight: 350;\n  line-height: 24px;\n  font-size: 16px;\n  color: var(--grey-color-90);\n}\n\n.skillStepperContainer {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.skillStepperWrapper {\n  width: 100%;\n  padding: 10px 40px;\n}\n\n.progressBarSteps {\n  width: 100%;\n  height: 6px;\n  border-radius: 4px;\n  background-color: #b0caeb;\n  display: flex;\n  position: relative;\n}\n\n.progressBar {\n  background-color: #3973ca;\n  height: 6px;\n  border-radius: 4px;\n}\n\n.progressBarPointer {\n  width: 15px;\n  height: 15px;\n  margin-top: -5px;\n  border: 1px solid var(--grey-gradient-start-color-10);\n  border-radius: 50%;\n  background-color: #3973ca;\n  position: absolute;\n  z-index: 1;\n}\n\n.progressBarGap {\n  position: absolute;\n  height: 6px;\n  width: 4px;\n  background-color: var(--grey-gradient-start-color-10);\n}\n\n.progressBarLabelContainer {\n  display: flex;\n  justify-content: space-between;\n}\n\n.progressStepContainer {\n  width: 100%;\n  &:first-child {\n    padding-left: 40px;\n  }\n}\n\n.progressBarLabels {\n  position: relative;\n  left: -36px;\n  top: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"skillContainer": `PGhWIr5uBGDj4B9QO3jG`,
	"skillLeftContainer": `do2exQYhwlRBEtaZmAY9`,
	"skillNameContainer": `oiZi707Y7WqFhaJYa4HH`,
	"skillName": `iXBZhAVheyrETYU3jqWv`,
	"skillDescription": `dUBbt_VnJ4T0pIvIF9Li`,
	"skillStepperContainer": `qIz1w2NKWmasVc4o7VFQ`,
	"skillStepperWrapper": `Z60KmyMROohtV56fOFgf`,
	"progressBarSteps": `TYbnX3wOnFS_GpK4TiLg`,
	"progressBar": `CKW5EO_SE3xhFeANdJiI`,
	"progressBarPointer": `QWOz8L2zbgLinA_iHXv8`,
	"progressBarGap": `XdNMUmGodrJ6IuSrMf9o`,
	"progressBarLabelContainer": `Fu9Os8DK2rKKIvgdONcw`,
	"progressStepContainer": `evZ09L9aPPpEEfhlZSw5`,
	"progressBarLabels": `b4FPr6Z_Hw1NwUCIf0xY`
};
export default ___CSS_LOADER_EXPORT___;
